import { render } from "./deduct.vue?vue&type=template&id=e82fb2de"
import script from "./deduct.vue?vue&type=script&lang=js"
export * from "./deduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__